import { render, staticRenderFns } from "./FolderStatusQuestionCreateDialog.vue?vue&type=template&id=43b7a4c0&scoped=true"
import script from "./FolderStatusQuestionCreateDialog.vue?vue&type=script&lang=js"
export * from "./FolderStatusQuestionCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderStatusQuestionCreateDialog.vue?vue&type=style&index=0&id=43b7a4c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b7a4c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VForm,VSwitch,VTooltip})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
